import React from 'react';
import Hero from '../components/Hero';
import Card from '../components/Card';
import { Briefcase, Gavel, ShieldCheck, Cpu, Anchor, Users, Globe, Target, ShieldAlert } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './Insurance.css';

const BusinessInsurance = () => {
    const { t } = useLanguage();

    const bizPlans = [
        { key: 'ft_biz_liab', icon: Gavel, desc: 'Highest coverage at lowest premium for any business-related legal liability.' },
        { key: 'ft_biz_indem', icon: ShieldCheck, desc: 'Professional indemnity for experts against errors and omissions.' },
        { key: 'ft_biz_cyber', icon: Cpu, desc: 'Advanced cybersecurity protection against data breaches and hacking.' },
        { key: 'ft_biz_marine', icon: Anchor, desc: 'Secure your goods in transit across sea, air, rail, and road.' },
        { key: 'ft_biz_comp', icon: Users, desc: 'Mandatory workmen compensation insurance for your workforce.' },
    ];

    return (
        <div className="insurance-page">
            <Hero 
                title={t('ft_business')}
                subtitle="Small business or global enterprise — our corporate insurance portfolio grows with you. Mitigate risks and secure your bottom line."
                bgGradient={true}
                image="/assets/business-hero.png"
            />

            <section className="section-padding container">
                <div className="text-center mb-60">
                    <h2 className="section-title">Corporate Risk Solutions</h2>
                    <p className="section-subtitle">We go beyond simple policies with specialized risk assessment for every industry sector.</p>
                </div>
                
                <div className="grid grid-3">
                    {bizPlans.map((plan, i) => (
                        <Card 
                            key={i}
                            title={t(plan.key)}
                            description={plan.desc}
                            icon={plan.icon}
                            link="/contact"
                        />
                    ))}
                </div>
            </section>

            <section className="features-grid section-padding" style={{ background: '#F8F9FA' }}>
                <div className="container">
                    <div className="text-center mb-60">
                        <h2 className="section-title">Enterprise Benefits</h2>
                    </div>
                    <div className="grid grid-2">
                        <div className="feature-item">
                            <Globe className="feature-icon" />
                            <h4>Global Network</h4>
                            <p>International support for multi-country operations and cross-border liability protection.</p>
                        </div>
                        <div className="feature-item">
                            <Target className="feature-icon" />
                            <h4>Fast Claims</h4>
                            <p>Minimum disruption to your business with our dedicated corporate claim advisors.</p>
                        </div>
                        <div className="feature-item">
                            <ShieldAlert className="feature-icon" />
                            <h4>Risk Assessment</h4>
                            <p>Complimentary annual risk audit from our insurance experts for your facilities.</p>
                        </div>
                        <div className="feature-item">
                            <ShieldCheck className="feature-icon" />
                            <h4>Continuity Planning</h4>
                            <p>Business interruption cover to keep your revenue stream stable during a loss.</p>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container text-center section-padding">
                <div className="cta-box glass">
                    <h3>Commercial Quote Inquiry</h3>
                    <p>Enter your details and our commercial insurance experts will prepare a custom proposal.</p>
                    <button className="btn btn-primary" onClick={() => window.location.href='/contact'}>Request Proposal</button>
                </div>
            </div>
        </div>
    );
};

export default BusinessInsurance;
